import { render } from "./ConfigureTemplate.vue?vue&type=template&id=6a35bc23"
import script from "./configure_template.js?vue&type=script&lang=js&external"
export * from "./configure_template.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__